import { ReactNode, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import UserProfileCard from "./UserProfileCard";
import logoImg from "../assets/logo.svg";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout-with-sidebar">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {/* Mobile: backdrop when sidebar is open */}
      <div
        className={`sidebar-backdrop ${sidebarOpen ? "sidebar-backdrop--visible" : ""}`}
        aria-hidden="true"
        onClick={() => setSidebarOpen(false)}
      />
      {/* Mobile: logo (left) + profile card + menu button (right) */}
      <header className="layout-mobile-header" aria-label="Mobile header">
        <Link to="/dashboard" className="layout-mobile-header-logo">
          <img src={logoImg} alt="Logo" />
        </Link>
        <div className="layout-mobile-header-right flex items-center">
          <UserProfileCard variant="compact" />
          <span className="layout-mobile-header-divider" aria-hidden />
          <button
            type="button"
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <span className="sidebar-toggle-bar" />
            <span className="sidebar-toggle-bar" />
            <span className="sidebar-toggle-bar" />
          </button>
        </div>
      </header>
      <main className="layout-main">
        <div className="text-white">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
